import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
import App from './AppStore'
import Auth from './AuthStore'
import OrganizacionStore from './OrganizacionStore'
import RolStore from './RolStore'
import UserStore from './UserStore'
import ToasterStore from './ToasterStore'
import UbicacionStore from './UbicacionStore'
import VehiculoStore from './VehiculoStore'
import DriverStore from './DriverStore'
import DealerStore from './DealerStore'
import MovimientoStore from './MovimientoStore'
import NotificationStore from './NotificationStore'
import GruaStore from './GruaStore'
import EquipamientoStore from './EquipamientoStore'
import TodoCategoryStore from './TodoCategoryStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    App,
    Auth,
    OrganizacionStore,
    RolStore,
    UserStore,
    ToasterStore,
    UbicacionStore,
    VehiculoStore,
    DriverStore,
    DealerStore,
    MovimientoStore,
    NotificationStore,
    GruaStore,
    EquipamientoStore,
    TodoCategoryStore
  },
  plugins: [
    createPersistedState({
      paths: [
        'Auth.user',
        'Auth.token'
      ],
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { secure: (process.env.NODE_ENV === 'production') }),
        removeItem: key => Cookies.remove(key)
      }
    })
  ]
})
